// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3tvBM","messages":"Chat_messages__3rF8w","dateDivider":"Chat_dateDivider__3l-gW"};